export default __webpack_public_path__ + "static/media/ie.8efe7dca.svg";